import { Suspense } from "react";
import type { ReactElement } from "react";
import { TaskProvider } from "@pages/plan/context/TaskContext";
import { ErrorBoundary } from "@components/ui/error-boundary";
import PrivateRoute from "./privateRoute";
import type { UserRole } from "@utils/rbac";

const routeFallback = (
  <div className="flex min-h-screen items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-brand-primary" />
  </div>
);

export const withSuspense = (element: ReactElement) => (
  <ErrorBoundary>
    <Suspense fallback={routeFallback}>{element}</Suspense>
  </ErrorBoundary>
);

export const withTaskProvider = (element: ReactElement) => (
  <TaskProvider>{element}</TaskProvider>
);

export const withPrivateRoute = (element: ReactElement, roles?: UserRole[]) =>
  withSuspense(<PrivateRoute roles={roles}>{element}</PrivateRoute>);
